import React, { useState, useEffect } from "react";
import "./ProjectSection.css";
import Heading from "../Heading/Heading";
import Button from "../Button/Button";
import ProjectCard from "../ProjectCard/ProjectCard";
import { client } from "../../client";
import { fetchProjects } from "../../Utils/data";

export default function ProjectSection() {
  const [projects, setProjects] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    client.fetch(fetchProjects).then((data) => {
      setProjects(data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="projects_section">
      <div className="container padding_top_bottom maintain_top">
        <Heading MainHeader="OUR PROJECTS" />
        <div className="subtitle">
          <h2>Turnkey EPC Projects</h2>
          <h2>
            <span>2013 - 2019</span>
          </h2>
        </div>
        <div className="row">
          {loading ? (
            <p className="loading">Loading projects...</p>
          ) : (
            <>
              {projects?.map((project, index) => (
                <ProjectCard key={index} project={project} />
              ))}
            </>
          )}
        </div>
        <div className="btn_center">
          <Button btnLink="/projects" btnText="View More Projects" />
        </div>
      </div>
    </div>
  );
}
